module.exports = __webpack_public_path__ + "static/media/ZEN-3.52efade2.jpg";